import React, { useRef, useState } from "react";
import style from "./partnerProfileModal.module.scss";
import { useTranslation } from "react-i18next";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import SwitchTabs from "../../../shared/SwitchTabs/SwitchTabs";
import { FileText, History } from "lucide-react";
import PhotoViewer from "../PhotoViewer";
import { Expeditor, File, User } from "../../../../services";
import CloseIconNew from "../../../shared/icons/CloseIconNew";
import { toast } from "react-toastify";
import PartnerMainInfo from "./components/PartnerMainInfo";
import DocumentsTab from "./components/DocumentsTab";
import HistoryTab from "./components/HistoryTab";
import PartnerActions from "./components/PartnerActions";
import PartnerStatusToggle from "./components/PartnerStatusToggle";
import { useSelector } from "react-redux";

const PartnerProfileModal = ({ item, setShowModalInfo, onRefresh }) => {
  const { t } = useTranslation();
  const modalInfoRef = useRef(null);
  const { user } = useSelector((state) => state);

  const [activeTab, setActiveTab] = useState("documents");
  const [isChangingTab, setIsChangingTab] = useState(false);
  const [contentDirection, setContentDirection] = useState("left");

  // Состояния для PhotoViewer
  const [file, setFile] = useState();
  const [isPhotoViewerOpen, setIsPhotoViewerOpen] = useState(false);
  const [imgUrl, setImgUrl] = useState();

  // Состояния для решений по партнёру
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [isRejectLoading, setIsRejectLoading] = useState(false);

  // useClickOutside(modalInfoRef, () => {
  //   setShowModalInfo(false);
  // });

  const openViewPhoto = (fileType, fileId, onLoadingComplete) => {
    setFile(null);

    File.getDocumentByCompany(fileType, fileId)
      .then((response) => {
        console.log("response document ===>", response);
        onLoadingComplete();
        const file = new Blob([response.data], {
          type: response.data.type,
        });

        setFile({ file: file, type: response.data.type });

        const fileURL = URL.createObjectURL(file);
        if (response.data.type === "application/pdf") {
          window.open(fileURL, "_blank");
        } else {
          setImgUrl(fileURL);
          setIsPhotoViewerOpen(true);
        }
      })
      .catch((error) => {
        onLoadingComplete();
        console.log(t("partnerProfile.messages.documentLoadError"), error);
        toast.error(t("partnerProfile.messages.documentLoadError"));
      });
  };

  const handleClosePhotoViewer = () => {
    setIsPhotoViewerOpen(false);
  };

  const onDownload = () => {
    if (file) {
      let downloadElement = document.createElement("a");
      downloadElement.href = URL.createObjectURL(file.file);
      downloadElement.download = "document";
      downloadElement.click();
    }
  };

  const handleConfirmPartner = async () => {
    setIsConfirmLoading(true);
    try {
      await Expeditor.updatePartnerStatus(item.id, "Confirmed");
      toast.success(t("partnerProfile.messages.approveSuccess"));
      setShowModalInfo(false);
      onRefresh();
    } catch (error) {
      console.error(t("partnerProfile.messages.approveError"), error);
      toast.error(t("partnerProfile.messages.approveError"));
    } finally {
      setIsConfirmLoading(false);
    }
  };

  const handleRejectPartner = async () => {
    setIsRejectLoading(true);
    try {
      await Expeditor.updatePartnerStatus(item.id, "rejected");
      toast.success(t("partnerProfile.messages.rejectSuccess"));
      setShowModalInfo(false);
      onRefresh();
    } catch (error) {
      console.error(t("partnerProfile.messages.rejectError"), error);
      toast.error(t("partnerProfile.messages.rejectError"));
    } finally {
      setIsRejectLoading(false);
    }
  };

  const tabOptions = [
    {
      key: "documents",
      text: t("partnerProfile.tabs.documents"),
      icon: <FileText size={20} />,
    },
    {
      key: "history",
      text: t("partnerProfile.tabs.history"),
      icon: <History size={20} />,
    },
  ];

  const handleTabChange = (newTab) => {
    if (newTab === activeTab) return;

    const currentIndex = tabOptions.findIndex((option) => option.key === activeTab);
    const newIndex = tabOptions.findIndex((option) => option.key === newTab);

    if (newIndex > currentIndex) {
      setContentDirection("right");
    } else {
      setContentDirection("left");
    }

    setIsChangingTab(true);

    setTimeout(() => {
      setActiveTab(newTab);
      setIsChangingTab(false);
    }, 150);
  };

  return (
    <>
      <div className={style.modalOverlay}>
        <div ref={modalInfoRef} className={style.modalContent}>
          <div className={style.header}>
            <h2 className={style.title}>{t("partnerProfile.title")}</h2>
            <CloseIconNew fill="#212121" onClick={() => setShowModalInfo(false)} />
          </div>

          <PartnerMainInfo item={item} />

          <div className={style.tabsContainer}>
            <SwitchTabs options={tabOptions} activeOption={activeTab} onOptionChange={handleTabChange} />
          </div>

          <div
            className={`${style.tabContent} ${isChangingTab ? style.fadeOut : style.fadeIn} ${
              style[`from-${contentDirection}`]
            }`}
          >
            {activeTab === "documents" && (
              <DocumentsTab
                partnerId={item?.clientCompanyId ? item?.clientCompanyId : item?.expeditorCompanyId}
                onOpenViewPhoto={openViewPhoto}
              />
            )}

            {activeTab === "history" && <HistoryTab partnerId={item.id} />}
          </div>

          {user.type === "Client" && (
            <>
              {(item.state === "Confirmed" ||
                item.state === "UnActive" ||
                item.state === "RecoveryRequest") && (
                <PartnerStatusToggle item={item} onRefresh={onRefresh} />
              )}

              <PartnerActions
                item={item}
                onConfirm={handleConfirmPartner}
                onReject={handleRejectPartner}
                isConfirmLoading={isConfirmLoading}
                isRejectLoading={isRejectLoading}
              />
            </>
          )}
        </div>
      </div>

      {isPhotoViewerOpen && (
        <PhotoViewer
          imgUrl={imgUrl}
          onClose={handleClosePhotoViewer}
          onDownload={onDownload}
          ShowBtnDownload
        />
      )}
    </>
  );
};

export default PartnerProfileModal;
